/**
 * This directive can be used when opening a support article in a new tab.
 * It will track the click event and open the article in a new tab.
 * If the support article is not found, it will open the default link.
 *
 * How to use:
 * <a v-support-article="{ article: 'Online_Payments', analyticsArticleCode: 'online_payments_wizard' }" :href="defaultLink" target="_self"> click me </a>
 */

import Vue from 'vue';
import  { supportArticleUrl } from '../../../settings/utils/supportUrlsUtil';


Vue.directive('support-article', {
  bind(el, binding, vnode) {
    if (el.tagName === 'A' && !!el.href && el.target === '_self' &&
      binding.value.article && binding.value.analyticsArticleCode) {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        const { $track } = vnode.context.$root;
        const { article, analyticsArticleCode } = binding.value;
        const supportArticleLink = supportArticleUrl(article);
        $track('help_article_clicked', {'Article Code': analyticsArticleCode})
        window.open(supportArticleLink || el.href, '_blank');
      });
    }
  }
});
